module.exports = __webpack_public_path__ + "static/media/zichan_bg.f2ffa22e.png";